import { useApp, type Onglet } from "../state/store";

const ONGLETS: { id: Onglet; label: string }[] = [
  { id: "gares", label: "Gares" },
  { id: "profil", label: "Profil" },
  { id: "espace", label: "Espace-temps" },
  { id: "methode", label: "Méthode" },
];

/** Barre d'onglets + accès aux réglages. */
export function Onglets() {
  const onglet = useApp((s) => s.onglet);
  const setOnglet = useApp((s) => s.setOnglet);
  const reglages = useApp((s) => s.reglagesOuverts);
  const toggleReglages = useApp((s) => s.toggleReglages);
  return (
    <div className="onglets" role="tablist" aria-label="Sections">
      {ONGLETS.map((o) => (
        <button type="button" key={o.id} role="tab" aria-selected={onglet === o.id} onClick={() => setOnglet(o.id)}>
          {o.label}
        </button>
      ))}
      <button type="button" className="reglages-bouton" aria-pressed={reglages} onClick={toggleReglages} title="Matériel, temps d'arrêt, hypothèses">
        Réglages
      </button>
    </div>
  );
}
